import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const cart = useCart();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      if (attempts.current > 12) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (data.kind !== "address_change") cart.clear();
          setTimeout(() => navigate(`/order/${data.order_id}`), 1200);
          return;
        }
      } catch (e) {}
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []); // eslint-disable-line

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[#08080C] flex flex-col items-center justify-center px-8 text-center">
      {status === "checking" && (<><Loader2 className="w-12 h-12 text-amber-400 animate-spin mb-4" /><p className="text-slate-300">Vérification du paiement…</p></>)}
      {status === "paid" && (<><CheckCircle2 className="w-16 h-16 text-emerald-400 mb-4" /><h1 className="text-2xl font-bold text-slate-100">Paiement réussi</h1><p className="text-slate-400 mt-1">Redirection…</p></>)}
      {status === "error" && (<><XCircle className="w-16 h-16 text-rose-400 mb-4" /><h1 className="text-2xl font-bold text-slate-100">Paiement non confirmé</h1><button onClick={() => navigate("/")} className="mt-4 text-amber-400 font-mono">Retour au catalogue</button></>)}
    </div>
  );
}
